<template>
    <v-card outlined class="inventario">
        <div class="d-flex align-center flex-wrap px-4 pt-3">
            <span class="inventario__title">Inventario actual</span>
            <FilterBadges :badges="filterBadges" class="ml-2"></FilterBadges>
            <v-spacer></v-spacer>
            <StatusChip v-if="!loading && !error && lowCount" :label="lowCount + ' bajo mínimo'" tone="warning"
                icon="fas fa-triangle-exclamation"></StatusChip>
            <StatusChip v-else-if="!loading && !error && rows.length" label="Sin faltantes" tone="success"
                icon="fas fa-circle-check"></StatusChip>
        </div>
        <v-card-text>
            <p v-if="error" class="inventario__error" role="alert">{{ error }}</p>
            <template v-else>
                <v-text-field v-model="search" prepend-inner-icon="fas fa-search" label="Buscar producto o sucursal"
                    filled outlined hide-details clearable class="form-compact mb-3"></v-text-field>
                <v-data-table dense :headers="headers" :items="rows" :search="search" :loading="loading"
                    loading-text="Cargando... espera un momento" no-data-text="Sin existencias" :items-per-page="8"
                    :footer-props="{ 'items-per-page-options': [8, 20, 50] }" sort-by="producto">
                    <template v-slot:[`item.existencia`]="{ item }">{{ quantity(item.existencia) }} {{ item.unidad }}</template>
                    <template v-slot:[`item.minStock`]="{ item }">{{ item.minStock ? quantity(item.minStock) : '—' }}</template>
                    <template v-slot:[`item.bajo`]="{ item }">
                        <StatusChip v-if="item.bajo" label="Bajo mínimo" tone="warning"></StatusChip>
                    </template>
                </v-data-table>
            </template>
        </v-card-text>
    </v-card>
</template>
<script>
import StatusChip from '@/components/shared/StatusChip.vue';
import DashboardDataService from '@/service/dashboard/DashboardDataService';
import { dashboardFilterMixin, dashboardWidgetMixin } from '@/mixins/dashboardWidgetMixin';
import FilterBadges from './FilterBadges.vue';
import { isLowStock } from './dashboardData';

/**
 * Existencias por producto y sucursal (`api/v1/dashboard/inventario`): suma de los lotes vivos. Marca "Bajo mínimo"
 * cuando el producto tiene mínimo configurado y no lo alcanza. La unidad (piezas o kg) viene con cada fila: no se
 * suman productos de unidades distintas. El backend limita a la sucursal del usuario si no es administrador.
 */
export default {
    name: 'InventarioResumen',
    components: { FilterBadges, StatusChip },
    mixins: [dashboardWidgetMixin, dashboardFilterMixin],
    filterScope: { sucursal: true, producto: true },
    data() {
        return {
            raw: [],
            search: '',
            headers: [
                { text: 'Producto', value: 'producto' },
                { text: 'Sucursal', value: 'sucursal' },
                { text: 'Existencia', value: 'existencia', align: 'end' },
                { text: 'Mínimo', value: 'minStock', align: 'end' },
                { text: 'Estado', value: 'bajo', align: 'center' }
            ]
        };
    },
    computed: {
        rows() {
            // La sucursal la filtra el backend; el producto, aquí (ya vienen todos los productos de esa sucursal).
            const product = this.filters.productoId;
            return this.raw
                .filter((row) => !product || row.productoId === product)
                .map((row) => ({ ...row, bajo: isLowStock(row) }));
        },
        lowCount() {
            return this.rows.filter((row) => row.bajo).length;
        }
    },
    created() {
        this.reload();
    },
    methods: {
        quantity(value) {
            return Number(value || 0).toLocaleString('es-MX', { maximumFractionDigits: 2 });
        },
        reload() {
            return this.loadWidget(() => DashboardDataService.inventario(this.filters.sucursalId), (data) => {
                this.raw = Array.isArray(data) ? data : [];
            });
        }
    }
};
</script>
<style scoped>
/* Sin clases `text-*` de Vuetify en títulos: main.css les cambia la fuente. */
.inventario__title {
    font-size: 1rem;
    font-weight: 700;
}
.inventario__error {
    margin: 0;
    font-size: 13px;
    color: var(--v-error-base);
}
</style>
